import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface MarkPassedConfirmationDialogData {
  guestName: string;
}

@Component({
  selector: 'app-mark-passed-confirmation-dialog',
  templateUrl: './mark-passed-confirmation-dialog.component.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule]
})
export class MarkPassedConfirmationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<MarkPassedConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MarkPassedConfirmationDialogData
  ) { }

  onActionClick(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}
